import { useMemo } from "react";

const DEFAULT_RANGE_IN_DAYS = 28;

/**
 * Returns a fixed 28-day date range ending today, computed once on mount.
 */
export const useGscDateRange = () => {
    return useMemo(() => {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(startDate.getDate() - DEFAULT_RANGE_IN_DAYS);

        return {
            startDate: startDate.toISOString().split("T")[0],
            endDate: endDate.toISOString().split("T")[0],
        };
    }, []);
};
